import {useQuery} from "@tanstack/react-query"
import {Moment} from "config"
import {API} from "config"

const useOrdersList = (page = 1, term = null, type = null, status = null, client = null, distributor = 'matriz', order_by = null, period, item = null, state = null) => useQuery({
    queryKey: ['orders', page, term, type, status, client, distributor, order_by, period, item, state], queryFn: async () => {
        const callback = await API.get(`/orders/list?page=${page}&start=${Moment(period[0]).unix()}&end=${Moment(period[1]).unix()}${term ? `&term=${term}` : ''}${type ? `&type=${type}` : ''}${status ? `&status=${status}` : ''}${client ? `&client=${client}` : ''}${distributor ? `&distributor=${distributor}` : ''}${order_by ? `&order_by=${order_by}` : ''}${item ? `&item=${item}` : ''}${state ? `&state=${state}` : ''}`)
        return callback?.data
    }
})

export default useOrdersList
